import { OneOfElements } from '@shared/models/project.model';
import { projectGuards } from '../../guards/project-guards.helpers';
import { ProjectChangeType } from '../update-engine.models';
import type { ProjectChangeMap } from '../update-engine.models';

type ElementSoftDeleteChange =
  ProjectChangeMap[ProjectChangeType.ElementSoftDelete];

/**
 * Set {@link IElement.isDeleted} to true for proposal-scoped element deletion.
 *
 * @param element - Current element state
 * @param change - Soft-delete payload
 * @returns Partial element or undefined when not an {@link ElementKind.Element} or already deleted
 */
export const elementSoftDeleteToChange = (
  element: OneOfElements,
  _change: ElementSoftDeleteChange,
): Partial<OneOfElements> | undefined => {
  if (!projectGuards.is.element(element)) return undefined;
  if (element.isDeleted === true) return undefined;

  return { isDeleted: true };
};
